import { Link } from "gatsby"
import React from "react"

export default function MenuMobileItem({ children, to }) {
  return <Link className="ezds-menu--mobile-item" activeClassName="ezds-menu--mobile-item--active" to={to}>
    {children}
  </Link>
}
